(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeDetailController', EmployeeDetailController);

    /* Added UIFormAccess
    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Employee, User, Division, EmployeePhone) {
    */
    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone', 'UIFormAccess'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Employee, User, Division, EmployeePhone, UIFormAccess) {
        var vm = this;

        vm.employee = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        vm.employeePhones = EmployeePhone.query({employeeId: vm.employee.id});

        var unsubscribe = $rootScope.$on('telestatApp:employeeUpdate', function(event, result) {
            vm.employee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
